import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import LandingPageLayout from 'src/components/reusable-components/landing-page-layout';

export default function OrgNotFound() {
  const { t } = useTranslation('authentication-wall');
  return (
    <LandingPageLayout>
      <>
        <Box
          sx={{
            color: 'var(--color-text-primary)',
            fontSize: 'var(--font-size-2xl)',
            fontWeight: 'var(--font-weight-semibold)',
          }}
        >
          {t('orgNotFound.title')}
        </Box>
        <Box
          component='p'
          sx={{
            color: 'var(--color-text-secondary)',
            fontSize: 'var(--font-size-ms)',
            lineHeight: '21px',
          }}
        >
          {t('orgNotFound.body')}
        </Box>
        <Box
          component='a'
          href='https://support.forethought.ai/hc/en-us/requests/new'
          sx={{
            background: 'var(--mui-palette-primary-main)',
            borderRadius: 'var(--border-radius-button)',
            color: 'var(--color-solid-white)',
            cursor: 'pointer',
            display: 'block',
            fontSize: 'var(--font-size-s)',
            fontWeight: 'var(--font-weight-semibold)',
            height: 'auto',
            padding: '16px',
            textDecoration: 'none',
            textTransform: 'capitalize',
            userSelect: 'none',
            width: '100%',
          }}
        >
          {t('orgNotFound.getHelp')}
        </Box>
      </>
    </LandingPageLayout>
  );
}
